import { render, staticRenderFns } from "./CallDetail.vue?vue&type=template&id=2026aeae&scoped=true"
import script from "./CallDetail.vue?vue&type=script&lang=js"
export * from "./CallDetail.vue?vue&type=script&lang=js"
import style0 from "./CallDetail.vue?vue&type=style&index=0&id=2026aeae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2026aeae",
  null
  
)

export default component.exports